import React, { useState } from "react";
import Header from "../components/Header";
import Footer from "../components/Footer";
import { ChevronDown, Weight } from "lucide-react";
import { motion, AnimatePresence } from "framer-motion";

function Faq() {
  const [openIndex, setOpenIndex] = useState(null);
  const [showModal, setShowModal] = useState(false);
  const [animate, setAnimate] = useState(false);
  const [pendingIndex, setPendingIndex] = useState(null); // which FAQ to open after submit
  const [loading, setLoading] = useState(false);
const [pendingQuestion, setPendingQuestion] = useState("");

  const [formData, setFormData] = useState({
    name: "",
    company: "",
    email: "",
    question:"",
    phone:"",
  });

  // 🔹 Close modal
  const closeModal = () => {
    setAnimate(false);
    setTimeout(() => setShowModal(false), 300);
  };

  // 🔹 Handle input
  const handleInputChange = (e) => {
    const { name, value } = e.target;
    setFormData((prev) => ({ ...prev, [name]: value }));
  };

  const toggleFaq = (index) => {
    setOpenIndex(openIndex === index ? null : index);
  };
  return (
    <div>
      <Header />
      <main>
       
        <section className="hero-section1">
            <img src="/images/faqimage.jpg" alt="FAQ Banner" className="w-full h-auto"/> 
           </section>

        {/* 🔹 FAQ Section */}
        <section className="i ji">
          <span className="rc h s r vd fd/5 fh rm"></span>
          <div className="animate_top bb ze rj ki xn vq text-center">
            <motion.section
              initial={{ opacity: 0, y: 50 }}
              whileInView={{ opacity: 1, y: 0 }}
              viewport={{ once: true, amount: 0.2 }}
              transition={{ duration: 0.8 }}
            >
              <h2 className="fk vj pr kk wm on/5 gq/2 bb _b text-3xl font-bold">
                FAQs
              </h2>
            </motion.section>
          </div>
        </section>

        {/* 🔹 FAQ Accordion */}
        <div className="animate_top bb ze rj">
          <div className="max-w-3xl mx-auto">
            {[
              {
                q: "Are these leads opt-ins?",
                a: "Absolutely — data privacy is our first priority. All leads we deliver are completely compliant with global privacy regulations such as GDPR, CCPA, and CAN-SPAM. Our data is sourced only through verified, permission-based channels, ensuring that every contact has expressed consent to receive relevant B2B communications or has opted in through trusted publishing and content networks.",
              },
              {
                q: "How do you verify the accuracy and authenticity of leads?",
                 a: `
      At Pinakinedge Media, data quality is as important as data volume — every lead we deliver goes through a multi-layered verification and validation process to ensure accuracy, authenticity, and compliance.<br/><br/>
                        Every lead undergoes a multi-step verification process, including data validation, real-time email checks, and intent signal verification.<br/><br/>
                        We combine automation, human QA, and compliance checks to ensure each contact is accurate, active, and GDPR-compliant.
    `,
              },
              {
                q: "How often is your data refreshed or updated?",
                a: `
      At Pinakinedge Media we maintain a continuously refreshed and rigorously validated data ecosystem to ensure that every record you receive is accurate, current, and relevant.<br/>
                       <br/> <b>Here’s how we manage data freshness:</b><br/>
                        <ul><li>1. Ongoing Real-Time Updates</li><li>2.	Regular Data Refresh Cycles</li><li>3. Intent & Behavioral Data Updates</li><li>4. Continuous Validation & QA</li><li>5. Dynamic Compliance Monitoring</li></ul>
    `,
              },
              {
                q: "Can we integrate your leads with our CRM or marketing automation tools (like HubSpot, Salesforce, or Marketo)?",
               a: `
      Yes — our leads can be easily integrated with your CRM or marketing automation platforms, including HubSpot, Salesforce, Marketo, and more. We provide data in flexible formats, support direct API or CRM uploads, and ensure all integrations are secure, compliant, and aligned with your data structure.
    `,
              },
               {
                q: "How do you handle duplicate or invalid leads?  ",
               a: `
      We run automated and manual checks to eliminate duplicates and invalid records before delivery. Every lead is verified for accuracy and uniqueness, and if a duplicate or invalid entry is ever identified, we replace it promptly at no cost.
    `,
              },
               {
                q: "What’s your process for lead replacement if quality issues arise?   ",
               a: `
     In the rare event of a quality issue, we promptly verify the lead and replace it at no cost within the agreed SLA period. We define clear quality standards before each campaign, monitor performance closely, and ensure every replacement meets your Ideal Customer Profile and compliance requirements.
    `,
              },
            ].map((faq, i) => (
              <div
                key={i}
                className={`bg-white shadow-md rounded-2xl mb-4 border transition ${
                  openIndex === i ? "border-blue-500" : "border-gray-100"
                }`}
              >
                <button
                  onClick={() => toggleFaq(i, faq.q)}
                  className="flex justify-between w-full text-left px-6 py-5 faqcs"
                >
                  <span
                    className={`text-lg font-semibold csfa ${
                      openIndex === i ? "text-blue-600" : "text-gray-900"
                    }`}
                  >
                    {faq.q}
                  </span>
                  <div className="icontest flex items-center space-x-2">
                    <span
                      className={`text-sm fabtn ${
                        openIndex === i ? "text-gray-600" : "text-blue-700"
                      }`}
                    >
                    </span>
                    <ChevronDown
                      className={`transition-transform duration-300 ${
                        openIndex === i
                          ? "rotate-180 text-gray-600"
                          : "text-gray-400"
                      }`}
                    />
                  </div>
                </button>
   <AnimatePresence>
  {openIndex === i && (
    <motion.div
      initial={{ height: 0, opacity: 0 }}
      animate={{ height: "auto", opacity: 1 }}
      exit={{ height: 0, opacity: 0 }}
      transition={{ duration: 0.3 }}
    >
      <div
      className="faqanswer bb on/5 wo/3 text-gray-700 border-t border-gray-100 leading-relaxed"
        dangerouslySetInnerHTML={{ __html: faq.a }} // ✅ correct usage
      ></div>
    </motion.div>
  )}
</AnimatePresence>
              
              </div>
            ))}
          </div>
        </div>
        <br/>
      </main>
      <Footer />
    </div>
  );
}

export default Faq;
